import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileExport"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.75 15.75H19.6275L17.6925 17.6925L18.75 18.75L22.5 15L18.75 11.25L17.6925 12.3075L19.6275 14.25H9.75V15.75ZM16.5 7.50001V10.5H15V9.00001H10.5C9.67157 9.00001 9 8.32844 9 7.50001V3.00001H3V21H15V19.5H16.5V21C16.5 21.8284 15.8284 22.5 15 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21V3.00001C1.5 2.17159 2.17157 1.50001 3 1.50001H10.5C10.6994 1.49886 10.891 1.57712 11.0325 1.71751L16.2825 6.96751C16.4229 7.10905 16.5012 7.30066 16.5 7.50001ZM10.5 3.30754V7.50004H14.6925L10.5 3.30754Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileExport.vue"]]);
